<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import Star from '@/components/Star';

const store = useStore();
const info = computed(() => store.state.appInfo);

const emit = defineEmits(['confirm']);

const handleConfirm = () => {
  emit('confirm');
};
</script>
<template>
  <div class="ios-ratings">
    <div class="title">
      <h2>
        {{ info.language_list.reviews }}
        <i class="iconfont icon-fanye"></i>
      </h2>
    </div>
    <div class="flex score-item align-center justify-between">
      <div class="score-num">{{ info.score }}</div>
      <div>
        <Star :score="info.score"></Star>
        <div class="ratings-num">
          {{ info.comment }}{{ info.language_list.ratings }}
        </div>
      </div>
    </div>
    <h2 class="ratings-title">{{ info.language_list.most_helpful }}</h2>
    <div class="ratings-list">
      <ul>
        <li
          v-for="(item, index) in info.comment_list"
          :key="index"
          class="ratings-item">
          <div class="item-tit">{{ item.title }}</div>
          <div class="flex align-center">
            <Star :score="item.score"></Star>
            <span class="user">{{ item.user_name }}</span>
          </div>

          <div class="content">{{ item.content }}</div>
        </li>
      </ul>
    </div>
    <div class="to-rate">
      <div class="tit">{{ info.language_list.tap }}</div>
      <div class="star">
        <i
          class="iconfont icon-ai64"
          @click="handleConfirm"></i>
        <i
          class="iconfont icon-ai64"
          @click="handleConfirm"></i>
        <i
          class="iconfont icon-ai64"
          @click="handleConfirm"></i>
        <i
          class="iconfont icon-ai64"
          @click="handleConfirm"></i>
        <i
          class="iconfont icon-ai64"
          @click="handleConfirm"></i>
      </div>
      <div class="rate-btns flex align-center justify-between">
        <div
          class="flex align-center justify-center"
          @click="handleConfirm">
          <i class="iconfont icon-bianji"></i>
          <span>{{ info.language_list.write }}</span>
        </div>
        <div
          class="flex align-center justify-center"
          @click="handleConfirm">
          <i class="iconfont icon-wenhao-xianxingyuankuang"></i>
          <span>{{ info.language_list.support }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.ios-ratings {
  .star-rating {
    font-size: 16px;
    .star {
      width: 16px;
    }
    .full-star,
    .half-star {
      color: #000 !important;
    }
  }
  .ratings-list {
    .star-rating {
      font-size: 11px;
      .star {
        width: 11px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.ios-ratings {
  color: #000;
  .title {
    .iconfont {
      color: #000;
    }
    h2 {
      margin: 20px 0 8px 0;
    }
  }
  .score-num {
    font-size: 60px;
  }
  .ratings-num {
    color: #666;
    text-align: center;
    font-size: 12px;
    margin-top: 10px;
  }
  .score-item {
    margin: 40px 0;
  }
  .ratings-title {
    font-size: 16px;
  }
  .ratings-list {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    margin: 12px 0;
    ul {
      display: flex;
      flex-wrap: nowrap;
      padding: 5px 5px 10px 5px;
      width: fit-content;
      margin-left: -5px;
      li {
        padding: 10px 12px;
        margin: 0 5px;
        width: 295px;
        height: 184px;
        border-radius: 6px;
        background: #ffffff;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.3);
      }
      .item-tit {
        font-size: 14px;
        color: #333333;
        margin-bottom: 12px;
      }
      .content {
        font-size: 12px;
        margin-top: 12px;
        color: #555555;
      }
      .user {
        padding-left: 10px;
        color: #555555;
        font-size: 10px;
      }
    }
  }
  .to-rate {
    text-align: center;
    .star {
      margin: 12px 0;
    }
    .icon-ai64 {
      font-size: 28px;
      &:hover {
        font-weight: bolder;
      }
    }
  }
  .rate-btns {
    div {
      width: 160px;
      height: 40px;
      border-radius: 12px;
      background: #e6e6e6;
      color: var(--main-color);
      .iconfont {
        padding-left: 5px;
      }
    }
  }
}
</style>
